import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScLeaveRegistration = styled.div`
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  width: 100%;
  background-color: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  border-radius: 24px;
  box-sizing: border-box;
  padding: 32px;

  .subTitle {
    ${typography['body1regular']}
    font-weight: 400;
    text-align: center;
    width: 100%;
    margin-bottom: 32px;
  }

  .firstStepButtons {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .close {
      text-transform: none;
      color: ${({ theme }) => theme.color2};
      ${typography['body1regular']}
      height: 24px;
    }
  }

  .restStepsButtons {
    width: 100%;
    display: flex;
    gap: 8px;

    button {
      min-width: auto;

      &:first-child {
        border-radius: 50px;
        .awareWrap {
          border-radius: 50px;
        }
      }
    }
  }

  @media (${device.mobileS}) {
    max-width: calc(100% - 16px);
    padding: 32px 16px;
  }
`;

export const ScTitle = styled.h3`
  ${typography['headline2']}
  text-align: center;
  color: ${({ theme }) => theme.blackColor};
  text-transform: uppercase;
  margin-top: 32px;
  margin-bottom: 16px;

  @media (${device.mobileS}) {
    ${typography['headline2mobile']}
  }
`;
